export default {
    'open_equity':'Starting Equity',
    'bonus':'Bonus',
    'closed_positions':'Closed Positions',
    'finance':'Finance',
    'watchlist':'Watchlist',
    'calendar':'Calendar',
    'symbol_information':'Symbol Information',
    'contact_size':'Contact size',
    'min_tick_size':'Min Tick Size',
    'min_lot':'Min Lot',
    'max_lot':'Max Lot',
    'pip_size':'Pip Size',
    'stop_limit_levels':'Stop & Limit Levels',
    'base_currency':'Quote Currency',
    'swap_type':'Swap Type',
    'digits':'Digits',
    'trade_id':'Trade ID',
    'sell_buy':'Sell/Buy',
    'instrument':'Instrument',
    'open_current_price':'Open/Current Price',
    's_slash_l':'S/L',
    'profit_slash_loss':'Profit/Loss',
    'net_pl':'Net P/L',
    'comment':'Comment',
    'action':'Action',
    'proximity':'Proximity',
    'buy_stop':'Buy Stop',
    'buy_limit':'Buy Limit',
    'stop_loss':'Stop Loss',
    'rate':'Rate',
    'take_profit':'Take Profit',
    'price':'Price',
    'maximum_20_characters':'Maximum 20 characters',
    'btn_place_buy_order':'Place Buy Order',
    'btn_place_sell_order':'Place Sell Order',
    'change':'Change',
    'descrption':'Descrption',
    'asset_class':'Asset Class', 
    'subclass':'Subclass',
    'major':'Major',
    'size_of_1_pip':'Size of 1 pip',
    'Min_position_size':'Min. Position Size',
    'Max_position_size':'Max. Position Size',
    'leverage':'Leverage',
    'daily_swap_points':'Daily swap points',
    'long':'Long',
    'short':'short',
    'market_hours_local_time':'Market Hours (Local Time)',
    'main_trading':'Main/Trading',
    'copy_trade':'Copy Trade',
    'view_modes':'View Modes',
    'reports':'Reports',
    'pivot_table':'Pivot Table',
    'pp':'PP',
    's1':'S1',
    's2':'S2',
    's3':'S3',
    'r1':'R1',
    'r2':'R2',
    'r3':'R3',
    'list_property':'List Property',
    'overview':'Overview ',
    'day_low':'Day Low',
    'prev_close':'Prev Close',
    'day_high':'Day High',
    '52_week_low':'52 Week Low',
    '1_day_range':'1 Day range',
    '52_day_range':'52 Day range',
    'daily':'Daily',
    'weekly':'Weekly',
    'monthly':'Monthly',
    'moving_averages':'Moving Averages',
    'technical_indicators':'Technical Indicators',
    'charts':'Charts',
    'trade_log':'Trade Log',
    'create_new_watchlist':'Create New Watchlist',
    'net_profit':'Net Profit',
    'maximum_equity_drawdown':'Maximum Equity Drawdown',
    'profit_percentage':'Profit Percentage',
    'opening_balance':'Starting Balance',
    'current_balance':'Current Balance',
    'deposit':'Deposit',
    'withdrawal':'Withdrawal',
    'economic_calendar':'Economic Calendar',
    'dashboard': 'Dashboard',
    'markets':'Markets',
    'portfolio':'Portfolio',
    'buzz':'Buzz',
    'view_profile': 'View Profile',
    'equity':'Equity',
    'realized_profit':'Realized Profit',
    'unrealized_profit':'Unrealized Profit',
    'balance':'Balance',
    'used_margin':'Used Margin',
    'free_margin':'Free Margin',
    'profile': 'Profile',
    'settings':'Settings',
    'theme':'Theme',
    'logout':'Logout',
    'trading_account':'Trading Account',
    'quick_links':'Quick Links',
    'back':'Back',
    'previous':'Previous',
    'forecast':'Forecast',
    'actual':'Actual',
    'data':'Date',
    'margin_level':'Margin Level',
    'news':'News',
    'unrealised_pl':'UNREALIZED NET P/L',
    'unrealised_gross_pl':'UNREALIZED GROSS P/L',
    'quantity':'Quantity',
    'price':'Price',
    'trailing_sl':'Trailing SL',
    'sell':'Sell',
    'buy':'Buy',
    'open_positions':'Open Positions',
    'close_all_profitable':'Close All Profitable',
    'close_all_losing':'Close All Losing',
    'close_all_buy':'Close All Buy',
    'close_all_sell':'Close All Sell',
    'no':'No',
    'yes':'Yes',
    'are_you_sure':'Are you sure you want to',
    'current_market_rates':'at the current market rates?',
    'close_all':'Close All',
    'watchlists':'Watchlists',
    'default':'Default',
    'add_new_watchlist':'Add New Watchlist',
    'delete_watchlist?':'Are you sure want to delete this Watchlist?',
    'cancel':'Cancel',
    'delete':'Delete',
    'delete_alert':'Are you sure want to delete this alert?',
    'condition':'Condition',
    'triggered':'Triggered',
    'active':'Active',
    'alert':'Alert',
    'alerts':'Alerts',
    'going_below':'Going Below',
    'going_above':'Going Above',
    'bid_price':'Bid Price',
    'ask_price':'Ask Price',
    'symbol':'Symbol',
    'edit_alert':'Edit Alert',
    'create_alert_on':'Create Alert on',
    'info':'Info',
    'daily_range':'Daily Range',
    'spread':'Spread',
    'contract_size':'Contract Size',
    'min_trade_size':'Min Trade Size',
    'max_trade_size':'Max Trade Size',
    'swap_long':'Swap Long',
    'swap_short':'Swap Short',
    'create_alert':'Create Alert',
    'remove_watchlist':'Remove from watchlist',
    'trading_view_chart':'Trading View Chart',
    'chart':'Chart',
    'add':'Add',
    'add_instruments_watchlist':'Add Instruments to your Watchlist',
    'h':'H',
    'l':'L',
    'cryptos':'Cryptos',
    'indices':'Indices',
    'forex':'Forex',
    'fx':'FX',
    'stocks':'Stocks',
    'comm':'Comm',
    'commodities':'Commodities',
    'low':'Low',
    'high':'High',
    'change_percentage':'Change %',
    'bid':'Bid',
    'ask':'Ask',
    'order':'Order',
    'commission':'Commission',
    'swap':'Swap',
    'open_date':'Open Date',
    'lots':'Lots',
    'b_slash_s':'B/S',
    'open_price':'Open Price',
    'order_price':'Order Price',
    'current_price':'Current Price',
    'comments':'Comments',
    'modify':'Modify',
    'close':'Close',
    'ok':'Ok',
    'trailing_stop':' Trailing Stop',
    'trailing_stop_loss':'Trailing Stop Loss',
    'quntity':'Quntity',
    'price_level':'Price Level',
    'type':'Type',
    'trades':'Trades',
    'order_id':'Order ID',
    'modify_order':'Modify Order',
    'revert':'Revert',
    'id':'ID',
    'sl':'SL',
    'tp':'TP',
    'comm':'Comm',
    'close_order':'Close Order',
    'trail_s_slash_l':'Trail S/L',
    'pnl_s':'Pnl',
    'direction':'Direction',
    'modify_position':'Modify Position',
    'close_price':'Close Price',
    'close_date':'Close Date',
    'total_p_slash_l':'Total P/L',
    'place_new_order':'Place New Order',
    'close_time':'Close Time',
    'open_time':'Open Time',
    'p_slash_l':'P/L',
    'reason':'Reason',
    'qty':'Qty',
    'pending_orders':'Pending Orders',
    'order_type':'Order Type',
    'close_all_orders':'Are you sure you want to close all open Orders?',
    'place_order':'Place Order',
    'advanced_options':'Advanced Options',
    'available_margin':'Available Margin',
    'trade':'Trade',
    'positions':'Positions',
    'orders':'Orders',
    'history':'History',
    'summary':'Summary',
    'summary_from':'Summary From: ',
    'performance':'Performance',
    'profitability':'Profitability',
    'password_validation':'Password must be at least 8 characters long, one special character, one letter, one digit.',
    'note':'Note',
    'change_password':'Change Password',
    'submit':'Submit',
    'select_server_type':'Select Server Type',
    'create_demo_account':'Create demo account',
    'create_new_account':'Create a new account',
    'account_id':'Account ID',
    'name':'Name',
    'currency':'Currency',
    'security':'Security',
    'amount':'Amount',
    'select_leverage':'Select Leverage',
    'select_currency':'Select Currency',
    'save_settings':'Save Settings',
    'large':'Large',
    'small':'Small',
    'font_size':'Font Size',
    'units':'Units',
    'select_show':'Select Show',
    'order_position_size':'Order / Position Size In',
    'custom':'Custom',
    'month':'Month',
    'days':'Days',
    'day':'Day',
    'select':'Select',
    'history_range':'History Range',
    'default_lot_size':'Default Lot Size',
    'local_time':'Local Time',
    'server':'Server',
    'timezone':'Timezone',
    'enable':'Enable',
    'modify_trade':'Modify Trade',
    'open':'Open',
    'enter_quantity':'Enter quantity',
    'tooltip':'Tooltip',
    'field':'Field',
    'value':'Value',
    'date_time':'Date/Time',
    'market':'Market',
    'all':'All',
    'verify':'Verify',
    'volume':'Volume',
    'lot':'lot',
    'quantity_required':' Quantity is required.',
    'stop_loss_required':' Stop loss is required.',
    'distance_points':'Distance from Current Price',
    'points':'Points',
    'back_to_login':'Back to Login',
    'forgot_password':'Forgot Password?',
    'enter_username':'Enter Username',
    'login':'Login',
    'remember_me':'Remember me',
    'login_another_account':'Login with another Account',
    '2fa_verification':'2FA Verification',
    'my_profile':'My Profile',
    'user_name':'User Name',
    'email':'Email',
    'already_have_account':' Already have an account?',
    'register':'Register',
    'last_name':'Last Name',
    'first_name':'First Name',
    'password':'Password',
    'disable_two_factor_auth':'Disable Two-Factor Authentication',
    'enter_6_digit_code':'Enter the 6-digit verification code generated.',
    'enable_two_factor_authentication':'Enable Two-factor Authentication',
    'please_click_2fa_enable':'Please click the 2FA option you want to enable.',
    'download_authenticator_app':'Download an Authenticator App',
    'download_install_google_authenticator':'Download and install Authy or Google Authenticator to your phone or tablet.',
    'scan_code':'Scan The QR Code',
    "open_authentication_app_camera":"Open the authentication app and scan the image to the left, using your phone's camera",
    'login_code':'Log in with your Code',
    'two_factor_authentication':'Two-factor Authentication',
    '2fa_already_enabled':'2FA Already Enabled Please click the 2FA option you want to Disable.',
    'login_another_account':'Log In with another Account?',
    'usd':'USD',
    'eur':'EUR',
    'gbp':'GBP',
    'aud':'AUD',
    'enter_6_digit_code_placeholder':'Enter 6-digit Code',
    'enter_google_verification_code':'Enter Google verification code',
    'trading_id_placeholder':'Enter your trading id',
    'password_placeholder':'Enter your password',
    'email_placeholder':'Enter your email',
    'enter_old_password':'Enter Current password',
    'enter_new_password':'Enter new password',
    'enter_new_password_again':'Enter new password again',
    'alpha_numeric_dashes_underscores_spaces':'field may only contain alpha-numeric characters as well as dashes, underscores and spaces',
    'is_required':'is required',
    'field_must_be':' field must be',
    'or_more':'is or more.',
    'or_less':'is or less.',
    'must_be_greater_then':'must be Greater then.',
    'must_be_less_then':'is must be less then',
    'not_valid':'is not valid',
    'buy_stop_loss_error_message':'Stop Loss must be less than the Market Price',
    'trailing_stop_required':'Trailing Stop is required.',
    'trailing_stop_greater_zero':'Trailing Stop must be Greater than',
    'target_price_required':'Target Price is required.',
    'target_price_greater_trigger':'Target price Should be greater than current price and',
    'trigger_price':'Trigger Price',
    'price_required':'Price is required.',
    "price_must_be_greater_than":"Price must be greater than ",
    'target_price_greater_price_level':'Target Price must be Greater than Price Level',
    "price_must_be_less_than":"Price must be less than ",
    'and_greater_than_zero':'and Greater than',
    'stop_loss_less_price_level_greater_zero':'Stop loss must be less than Price Level and Greater than',
    'target_price_less_trigger':'Target price Should be Less than current price and greater than',
    "sell_stop":"Sell Stop",
    "sell_limit":"Sell Limit",
    'sell_stop_loss_error_message':'Stop Loss must be greater than the Market Price',
    'placed_order_pending_wait':'Your placed Order is pending please wait',
    'place_other_order':'Place Other Order',
    'no_account_id_found':'No Account ID Found',
    'target_price_must_less_than_trigger_price_greater_zero':'Target Price must be less than Trigger price and Greater than',
    'sell_stop_loss_greater_trigger_price':'Stop Loss must be greater than trigger price',
    'create_new_alert':'Create New Alert',
    'losing':'Losing',
    'winning':'Winning',
    'avg_trade_size':'Avg Trade Size',
    'asset':'Asset',
    'trades_lost':'Trades Lost',
    'trades_won':'Trades Won',
    'total_trades':'Total Trades',
    'total_trading_volume':'Total Trading Volume',
    'resend':'Resend',
    'reset_password_msg':'Please check the email address for instrutions to reset your password.',
    'server_type':'Server Type',
    'check_email':'Check Your Email',
    'technicals':'Technicals',
    'disable':'Disable',
    'amount_greater_100000':'Amount should not be greater than 100000',
    'x':'X',
    'password_required':'Password is required.',
    'proceed':'Proceed',
    'turnkey_forex':'TurnkeyForex',
    'coinexx':'Coinexx',
    'finpro_trading':'Finpro Trading',
    'hankotrade':'Hankotrade',
    'brokers':'Brokers',
    'select_broker':'Select a Broker',
    'edit_price_alert':'Edit Price Alert',
    'create_price_alert':'Create Price Alert',
    'maximum_100_characters':'Maximum 100 characters',
    'add_comment':'Add Comment',
    'price_must_be':'Price must be',
    'then':'then',
    'crossing_above':'Crossing Above',
    'crossing_below':'Crossing Below',
    'total_records':'Total Records',
    'no_data_found':'No Data Found',
    'show_more':'Show more',
    'show_less':'Show Less',
    'at':'at',
    'lot':'Lot',
    'trail':'Trail',
    'order_pending':'Order pending',
    'target_price_less_market_greater_zero':'Target Price must be less than Market Range and Greater than',
    'stop_loss_less_market_price_greater_zero':'Stop loss must be less than Current Market Price and Greater than',
    'stop_loss_greater_market_range':'Stop loss must be Greater than Market Range',
    'target_price_greater_market_price':'Target Price must be Greater than Current Market Price',
    'watchlist_create':'Create Watchlist',
    'update':'Update',
    'delete_symbol':'Delete Symbol',
    'are_sure_delete_symbol':'Are you sure want to delete this Symbol?',
    'symbol_name':'Symbol Name',
    'edit_symbol':'Edit Symbol',
    'enter_watchlist_name':'Enter Watchlist Name',
    'search_title':'Search symbols',
    'b':'B',
    's':'S',
    'a':'A',
    'username':'Username',
    'email_address':'Email Address',
    'old_password_validation':'Old Password is required.',
    'old_password_greater_characters':'Old Password may not be greater than 20 characters',
    'new_password_validation':'New Password is required',
    "confirm_password_is_required":"Confirm password is required.",
    'entered_password_not_match':'The entered passwords do not match. Please try again',
    'display_high_slash_low_grid_view':'Display High / Low in grid view',
    'display_spread_grid_view':'Display spread in grid view',
    'select_to_date':'Select To Date',
    'select_from_date':'Select From Date',
    'select_show_order_slash_position_size_in':'Show Order / Position Size In',
    'select_history_range':'Select History Range',
    'lot_size_greater_than':'Lot Size should not be greater than',
    'select_time_zone':'Select Time Zone',
    'select_font_size':'Select font size',
    'select_mode_view_suits':'Select The Mode of View Which Suits You.',
    'selected':'Selected',
    'basic_chart_view':'Basic Chart View',
    'grid_view':'Grid View',
    'multi_chart_view':'Multi Chart View',
    'settings_effect_trading_page':'These settings only take effect on the trading page.',
    'market_watch': 'Market Watch',
    'favorite': 'Favorite',
    'one_click_trading': 'One Click Trading',
    'new_watchlist': 'New Watchlist',
    'maximum_5_watchlists': 'You Can create maximum 5 watchlists.',
    'new_watchlist_successfully': 'New Watchlist has been Added successfully',
    'delete_watchlist': 'Delete Watchlist',
    'delete_watchlist_successfully':'Watchlist has been Deleted successfully',
    'edit_watchlist': 'Edit Watchlist',
    'watchlist_updated_successfully': 'Watchlist has been Updated successfully',
    'go_to_order': 'Go to order',
    'search_filter_fx': 'FX',
    'mon': 'Mon',
    'tue': 'Tue',
    'wed': 'Wed',
    'thu': 'Thu',
    'fri': 'Fri',
    'sat': 'Sat',
    'sun': 'Sun',
    'olivia_deo': 'Olivia Deo',
    'risk': 'Risk',
    'profit': 'Profit',
    'copiers': 'Copiers',
    'win_rate': 'Win Rate',
    'greetings_des': 'Greetings, my system that i present here requires the following account settings: 600usd--->0.01Lots We make veeeery Few trades here annually, between 60-200 trades, The very necessary trades so that - we keep our drawdown as Low as possible by taking the very needed trades. -We cruise at above an average of 30 pips per trade. *Allow all trades from this system to achieve similar results. SO feel welcome as you grow your account steadily with us and be very patient.',
    'live_profit': 'Live Profit',
    'overall': 'Overall',
    'advanced_seats': 'Advanced Seats',
    'trading': 'Trading',
    'drawDown' : 'DrawDown',
    'pips': 'Pips',
    'include_unrealized_pnl': 'Include Unrealized Pnl',
    'closed_trades_only': 'Closed Trades Only',
    'trades_volume': 'Trades Volume',
    'by_pair': 'By Pair',
    'best_worst': 'Best-Worst',
    'ranking': 'Ranking',
    'paris': 'Paris',
    'trading_news': 'Trading News',
    'prev': 'Prev',
    'next': 'Next',
    'follow': 'Follow',
    'investment': 'Investment',
    'open_date_time': 'Open Date & Time',
    'close_date_time' : 'Close Date & Time',
    'roll': 'Roll',
    'total': 'Total',
    'aud_slash_cad': 'AUD/CAD',
    'position_list': 'Position list',
    'trade_history': 'Trade History',
    'completed': 'Completed',
    'rejected': 'Rejected',
    'pending_closed': 'Pending Closed',
    'close_time_date': 'Close time date',
    'status': 'Status',
    'hedge_position': 'Hedge Position',
    'partial_close': 'Partial Close',
    'stop_loss_less_then': 'Stop loss must be less then',
    'greater_then_zero':'and Greater then',
    'trailing_stop_greater_one':'Trailing Stop must be Greater than',
    'greater_then': 'Target Price must be Greater then',
    'stop_loss_greater_then': 'Stop loss must be Greater then',
    'target_price_less_then': 'Target Price must be less then',
    'volume_required': 'Volume is required.',
    'volume_less_then': 'Volume must be less then',
    'PNL': 'PNL',
    'lot_size_partial': 'Lot size is to less to partial close',
    'price_greater_then': 'Price must be Greater then',
    'stop_loss_less_greater_then_zero': 'Stop loss must be less then Price Level and Greater then 0',
    'trailing_stop_greate_then_zero': 'Trailing Stop must be Greater then',
    'target_price_greater_price_level': 'Target Price must be Greater then Price Level',
    'stop_loss_trigger_price':'Stop loss must be Greater then Trigger price',
    'date_range': 'Date Range',
    'from': 'From',
    'to': 'To',
    'target_price_greater_then_zero': 'Target Price must be less then Trigger price and Greater then',
    'target_price_market_range_greater_zero': 'Target Price must be less then Market Range and Greater then',
    'order_list': 'Order list',
    'close_all_orders': 'Close All Orders',
    'close_all_trades': 'Close All Trades',
    'instrument_name': 'Instrument name',
    'trade_logs': 'Trade logs',
    'transaction_ID': 'Transaction ID',
    'add_more_leader': 'Add More Leader',
    'total_Profit': 'Total Profit',
    'invested': 'Invested',
    'market101_guard_enabled': 'Market101 Guard Enabled',
    'excessive_losses': 'The Leader has been disabled due to excessive losses.',
    'filter': 'Filter',
    'remember_filters': 'Remember Filters',
    'toggle': 'Toggle',
    'matrix': 'Matrix',
    'select_all': 'Select All',
    'term': 'Term',
    'apply': 'Apply',
    'clear_all': 'Clear all',
    'follow_more': 'Follow More',
    'go_to_dashboard': 'Go to Dashboard',
    'are_you_sure_stop_coping': 'Are you sure you want to stop copying this Master?',
    'invested_amount': 'Invested Amount',
    'max': 'Max',
    'insufficient_funds': 'Insufficient Funds in the Account.',
    'enter_valid_amount': 'Please enter a valid amount.',
    'maximum_amount_allowed': 'Maximum amount allowed is upto',
    'available_capital': 'Available Capital',
    'copy_open_trades': 'Copy Open Trades',
    'stop_following': 'Stop Following',
    'leaders': 'Leaders',
    'back_to_manual_trading': 'Back to Manual Trading',
    'advanced_stats': 'Advanced Stats',
    'view_all': 'View All',
    'roi': 'ROI',
    'load_more': 'Load More',
    'powered_by': 'Powered By',
    'act_trader': 'Act Trader',
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/en.js